import { createContext, useContext } from 'react'

export type RootElementContextType = {
  rootElement: HTMLElement | undefined
}

export const RootElementContext = createContext<RootElementContextType>({
  rootElement: undefined,
})

const useRootElementContext = () => {
  return useContext(RootElementContext)
}

export const useRootElement = () => {
  const { rootElement } = useRootElementContext()
  return rootElement
}
